/**
 * The hint row an attendees-first person picker shows under an empty query
 * (#15938): only attendees are listed until the user types, and this says
 * how to reach everyone else.
 *
 * Rendered OUTSIDE the picker's `role="listbox"`: a listbox may own only
 * options and groups, so a plain text row inside it is an
 * `aria-required-children` violation.
 */

import { ATTENDEE_FIRST_HINT } from '@/lib/meetings/attendee-first-ranking'

export function AttendeeFirstHint() {
  return (
    <p
      data-testid="attendee-first-hint"
      className="border-t border-stroke-extra-light px-3 py-2 text-xs text-text-secondary"
    >
      {ATTENDEE_FIRST_HINT}
    </p>
  )
}
